import { defineComponent as p, ref as m, openBlock as r, createElementBlock as t, withDirectives as i, Fragment as f, createTextVNode as d, toDisplayString as b, unref as _, createElementVNode as B, renderList as h, createBlock as y } from "vue";
import { l as E } from "./chunks/linkClickHandler.d9801523.js";
import { T } from "./chunks/Tooltip.b53afcfb.js";
import './assets/index5.css';const g = /* @__PURE__ */ B("div", { class: "Breadcrumbs__separator" }, null, -1), x = ["href", "aria-label", "data-event"], C = {
  key: 0,
  class: "Breadcrumbs__home"
}, D = /* @__PURE__ */ p({
  __name: "BreadcrumbItem",
  props: {
    breadcrumb: {},
    index: {}
  },
  setup(n) {
    const o = n, c = T, l = m(null), s = m(""), k = (e, a) => {
      E(e, a, void 0);
    }, v = () => {
      const e = l.value, a = e.clientWidth < e.scrollWidth;
      s.value = a ? o.breadcrumb.text : "";
    };
    return (e, a) => (r(), t("li", {
      class: "Breadcrumbs__item",
      onMouseover: v
    }, [
      g,
      e.breadcrumb.url ? i((r(), t("a", {
        key: 0,
        ref_key: "breadcrumbsEl",
        ref: l,
        href: e.breadcrumb.url,
        "aria-label": e.breadcrumb.text,
        target: "_self",
        "data-event": e.$ga.getDataEventValue("breadcrumbs", "item", ["a", e.breadcrumb.text]),
        class: "Breadcrumbs__item__text",
        onClick: a[0] || (a[0] = (u) => k(e.breadcrumb, u))
      }, [
        e.index === 0 ? (r(), t("span", C)) : (r(), t(f, { key: 1 }, [
          d(b(e.breadcrumb.text), 1)
        ], 64))
      ], 8, x)), [
        [_(c), s.value]
      ]) : i((r(), t("span", {
        key: 1,
        ref_key: "breadcrumbsEl",
        ref: l,
        class: "Breadcrumbs__item__text"
      }, [
        d(b(e.breadcrumb.text), 1)
      ])), [
        [_(c), s.value]
      ])
    ], 32));
  }
}), V = { class: "Breadcrumbs" }, S = /* @__PURE__ */ p({
  __name: "Breadcrumbs",
  props: {
    items: {}
  },
  setup(n) {
    return (o, c) => (r(), t("ul", V, [
      (r(!0), t(f, null, h(o.items, (l, s) => (r(), y(D, {
        key: s,
        index: s,
        breadcrumb: l
      }, null, 8, ["index", "breadcrumb"]))), 128))
    ]));
  }
});
export {
  S as Breadcrumbs
};
